export const demoNotifications = [
  {
    id: 1,
    type: "lead",
    title: "New enquiry received",
    body: "Arun Shetty sent an enquiry — Menu enquiry.",
    link: "/account",
    isRead: false,
    createdAt: "2026-09-18T10:32:00Z",
  },
  {
    id: 2,
    type: "review",
    title: "New review submitted",
    body: "Radhika M. left a 4-star review on Mangalore Harbour Fish House.",
    link: "/reviews",
    isRead: false,
    createdAt: "2026-09-17T16:10:00Z",
  },
  {
    id: 3,
    type: "review_flag",
    title: "A review was reported",
    body: "A review on your listing was flagged as suspected spam.",
    link: "/reviews",
    isRead: false,
    createdAt: "2026-09-16T09:45:00Z",
  },
  {
    id: 4,
    type: "listing",
    title: "Your listing is live!",
    body: "Harbour Seafood Cloud Kitchen was approved and is now visible to customers.",
    link: "/listings",
    isRead: true,
    createdAt: "2026-09-14T11:20:00Z",
  },
  {
    id: 5,
    type: "lead",
    title: "New enquiry received",
    body: "Priya Kamath sent an enquiry — Booking enquiry.",
    link: "/account",
    isRead: true,
    createdAt: "2026-09-13T08:05:00Z",
  },
];